
















































































































































import Vue from 'vue';
import VueAvatar from '../avatar.vue';
import VueTimeago from '../../plugins/timeago';
import VueClipboard from '../../plugins/clipboard';
import VueLightbox from 'vue-cool-lightbox';
import VueComment from "./comment.vue";
import VueCommentForm from './comment-form.vue';
import VueForm from './form.vue';
import VueFlag from '../flags/flag.vue';
import { default as mixins } from '../mixins/user';
import { Prop, Ref, Mixins } from "vue-property-decorator";
import { mapGetters, mapState, mapActions } from "vuex";
import Component from "vue-class-component";
import { mixin as clickaway } from "vue-clickaway";
import store from "../../store";
import VueUserName from "../user-name.vue";
import VueTags from '../tags.vue';
import { MicroblogMixin } from "../mixins/microblog";
import { User } from '@/types/models';
import useBrackets from "@/libs/prompt";
import IsImage from '@/libs/assets';

Vue.use(VueTimeago);
Vue.use(VueClipboard);

@Component({
  name: 'microblog',
  mixins: [clickaway, mixins],
  store,
  components: {
    'vue-avatar': VueAvatar,
    'vue-username': VueUserName,
    'vue-comment': VueComment,
    'vue-form': VueForm,
    'vue-comment-form': VueCommentForm,
    'vue-gallery': VueLightbox,
    'vue-flag': VueFlag,
    'vue-tags': VueTags
  },
  computed: {
    ...mapGetters('user', ['isAuthorized']),
    ...mapState('user', ['user'])
  },
  methods: {
    ...mapActions('microblogs', ['vote', 'subscribe', 'loadVoters', 'loadComments', 'toggleSponsored'])
  }
})
export default class VueMicroblog extends Mixins(MicroblogMixin) {
  private index: number | null = null;
  private commentDefault = { parent_id: this.microblog.id, text: '', assets: [] };

  @Ref('comment-form')
  readonly commentForm!: VueCommentForm;

  @Ref('microblog-text')
  readonly microblogText!: Element;

  @Prop()
  wrap!: boolean;

  mounted() {
    if (this.wrap && this.microblogText.clientHeight > 300) {
      this.isWrapped = true;
    }

    const pageHitHandler = () => {
      const rect = this.microblogText.getBoundingClientRect();

      if (rect.top >= 0 && rect.top <= window.innerHeight) {
        document.removeEventListener('scroll', pageHitHandler);
        store.dispatch('microblogs/hit', this.microblog);

        return true;
      }

      return false;
    }

    if (!pageHitHandler()) {
      document.addEventListener('scroll', pageHitHandler);
    }
  }

  reply(user: User) {
    this.commentForm.markdown.value += `@${useBrackets(user.name)}: `;
    this.commentForm.markdown.focus();
  }

  unwrap() {
    this.isWrapped = false;
  }

  deleteItem() {
    this.delete('microblogs/delete', this.microblog);
  }

  restoreItem() {
    store.dispatch('microblogs/restore', this.microblog);
  }

  copy() {
    if (this.$copy(this.microblog.url)) {
      this.$notify({type: 'success', text: 'Link prawidłowo skopiowany do schowka.'});
    }
    else {
      this.$notify({type: 'error', text: 'Nie można skopiować linku do schowka.'});
    }
  }

  get voters() {
    return this.splice(this.microblog.voters);
  }

  get totalComments() {
    return this.microblog.comments_count! - Object.keys(this.microblog.comments).length;
  }

  get images() {
    return this
      .microblog
      .assets
      .filter(asset => IsImage(asset.name!) && !asset.metadata)
      .map(asset => {
        return { src: asset.url, thumb: asset.thumbnail, url: asset.url };
      });
  }

  get opg() {
    return this
      .microblog
      .assets
      .find(asset => asset.metadata !== null)
  }

  get flags() {
    return store.getters['flags/filter'](this.microblog.id, 'Coyote\\Microblog');
  }
}
